export const noop = () => {
  throw Error('noop');
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export const capitalize = (str: string) => {
  return str.replace(/^\w/, (char: string) => char.toUpperCase());
};
